import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AbstractComponent } from '../../../../core/common/component/AbstractComponent';
import { Router } from '@angular/router';
import { PasswordIndexService } from './PasswordIndexService';
import { AuthService } from 'src/app/common/service/AuthService';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

/**
 * Login Component
 * ログイン画面のコンポーネントになります。
 * @author GAUSS
 * @since 2018/06/21
 */
@Component({
  selector: 'app-password',
  templateUrl: './PasswordIndex.html',
  styleUrls: ['./PasswordIndex.scss'],
})
export class PasswordIndexComponent extends AbstractComponent {
  errorMessage = '';
  inputForm: FormGroup;
  submitted: boolean = false;
  loginInvalid: boolean = false;


  /** コンストラクタ */
  public constructor(
    @Inject(DOCUMENT) private document: Document,
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
    super();
  }

  /** 初期処理 */
  public componentWillMount() {
    window.scrollTo(0, 0);
    this.document.body.style.backgroundColor = '#fff';
    this.inputForm = this.formBuilder.group({
      password: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required]),
      newPasswordConfirm: new FormControl('', Validators.required),
    });
  }

  /**  */
  public submit() {
    this.submitted = true;
    this.errorMessage = '';
    if (this.inputForm.invalid) {
      this.submitted = false;
      return false;
    }
    // this.router.navigate(['/dashboard']);
    let values = this.inputForm.value;
    if (values.newPassword != values.newPasswordConfirm) {
      this.submitted = false;
      this.errorMessage = '確認パスワードが違います';
      return false;
    }
    let pattern = /^(?=.*?[a-z])(?=.*?\d)(?=.*?[!-\/:-@[-`{-~])[!-~]{8,100}$/i;
    if (!values.newPassword .match(pattern)) {
      this.submitted = false;
      this.errorMessage = '半角英数字を含む8文字以上を設定してください。';
      return false;
    }
    this.authService.passwordChange(values.password, values.newPassword).subscribe((e) => {
      this.submitted = false;
      this.toastr.success('password update successful', '', { timeOut: 2000 });
      localStorage.removeItem('gaudi_token');
       this.router.navigate(['/login']);
    }, (e) => {
      this.submitted = false;
      this.loginInvalid = true;
      this.errorMessage = '現在のパスワードが違います。';
      setTimeout(() => {
        this.loginInvalid = false;
      }, 1000);
    });
  }
}
